import React from "react";
import BalanceTypeWith from "./balanceTypeWith";
import BalanceTypeWithout from "./balanceTypeWithout";
import BalanceTypeReplacement from "./balanceTypeReplacement";

const BalanceDetails = ({
  backgroundLocation,
  selectedList,
  withEntitlement: type,
}) => {
  if (type === "WITH") {
    return (
      <BalanceTypeWith
        backgroundLocation={backgroundLocation}
        item={selectedList}
      />
    );
  }

  if (type === "WITHOUT") {
    return (
      <BalanceTypeWithout
        backgroundLocation={backgroundLocation}
        item={selectedList}
      />
    );
  }

  if (type === "REPLACEMENT") {
    return (
      <BalanceTypeReplacement
        backgroundLocation={backgroundLocation}
        item={selectedList}
      />
    );
  }

  return null;
};

export default BalanceDetails;
